import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from "web-vitals";

function report(metric: Metric) {
  // Console for dev visibility
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info(`[web-vitals] ${metric.name}: ${Math.round(metric.value)} (${metric.rating})`);
  }
  // Forward to GA if present
  const w = window as unknown as { gtag?: (...args: unknown[]) => void };
  if (typeof w.gtag === "function") {
    w.gtag("event", metric.name, {
      value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_rating: metric.rating,
      non_interaction: true,
    });
  }
}

export function initWebVitals() {
  if (typeof window === "undefined") return;
  try {
    onCLS(report);
    onINP(report);
    onLCP(report);
    onFCP(report);
    onTTFB(report);
  } catch {
    /* noop */
  }
}
